import $ from 'jquery';
import ImageDelayLoadClass from './ImageDelayLoadClass';
import ThingsManagerClass from '../base/ThingsManagerClass';

/**
 * ImageDelayLoad一括管理
 * @param {String} _target 対象となるクラス名やid名 デフォルトbody
 *
 * @example
 * //対象：画像・アニメーション有り
 * <img class="js-delayLoad" src="/image/common/s.gif" data-src="/image/common/test.png">
 *      pc->/image/common/test.png
 *      sp->/image/common/sp/test.png
 * //対象：画像・アニメーション無し
 * <img class="js-delayLoad_noAnim" src="/image/common/s.gif" data-src="/image/common/test.png">
 *
 * //PCとSPでファイル名や拡張子が違う場合
 * <img class="js-imageChange or js-delayLoad_noAnim" src="/image/common/s.gif" data-src="/image/common/test.png" data-src_sp="/image/common/sp/test2.png">
 *
 * @example
 * //対象：背景・アニメーション有り
 * <div class="js-delayLoad_bg" data-src="/image/common/test.png"></div>
 * //対象：背景・アニメーション無し
 * <div class="js-delayLoad_bg_noAnim" data-src="/image/common/test.png"></div>
 *
 * //PCとSPでファイル名や拡張子が違う場合
 * <div class="js-delayLoad_bg or js-delayLoad_bg_noAnim" data-src="/image/common/test.png" data-src_sp="/image/common/sp/test2.png"></div>
 */
export default class ImageDelayLoadManagerClass extends ThingsManagerClass {
  constructor(_target) {
    super();
    this.name = 'ImageDelayLoadManagerClass';
    this._target = (_target) ? _target : 'body';
  }

  onCreate() {
    let self = this;
    let target = $(this._target);
    $('.js-delayLoad', target).each((index, element) => {
      self.things.push(new ImageDelayLoadClass($(element), false, true));
    });
    $('.js-delayLoad_noAnim', target).each((index, element) => {
      self.things.push(new ImageDelayLoadClass($(element), false, false));
    });
    $('.js-delayLoad_bg', target).each((index, element) => {
      self.things.push(new ImageDelayLoadClass($(element), true, true));
    });
    $('.js-delayLoad_bg_noAnim', target).each((index, element) => {
      self.things.push(new ImageDelayLoadClass($(element), true, true));
    });
    super.onCreate();
  }
}
